import { formValueSelector } from 'redux-form';
import { cardFields, CARD_FORM_SECTION } from '../constants/formFields';

const getSelected = (form: string, field: string) => (state: any) =>
  formValueSelector(form)(state, `${CARD_FORM_SECTION}.${field}`);

export const getCardTypeId = (form: string) => (state: any) =>
  getSelected(form, cardFields.CARD_TYPE_ID)(state);
export const getCommercialCardTypeId = (form: string) => (state: any) =>
  getSelected(form, cardFields.COMMERCIAL_CARD_TYPE_ID)(state);

export const getCardSchemaId = (form: string) => (state: any) =>
  getSelected(form, cardFields.SELECTED_CARD_SCHEMA)(state);
